/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { BasicDigitalFarmerAccount, DigitalFarmerAccount } from "../../azure-b2c/storage";

export const updateAccountEmailInAccountList = (
  accountList: BasicDigitalFarmerAccount[],
  account: DigitalFarmerAccount
) => {
  return accountList.map((a) => {
    return a.accountNumber === account.accountNumber
      ? { ...a, accountEmail: account.contact?.email || a.accountEmail }
      : a;
  });
};
